// extracted by mini-css-extract-plugin
export default {"wrapper":"RandomBundleBeneficialOffer_wrapper"};